module.exports = __webpack_public_path__ + "static/media/intro.7e7ae6b6.mp3";